__turbopack_context__.v({
  "colorPaletteSection": "knobSmithAudio-module__lBZfra__colorPaletteSection",
  "colorSwatch": "knobSmithAudio-module__lBZfra__colorSwatch",
  "colorSwatches": "knobSmithAudio-module__lBZfra__colorSwatches",
  "fontName": "knobSmithAudio-module__lBZfra__fontName",
  "imageGrid": "knobSmithAudio-module__lBZfra__imageGrid",
  "knobsVideo": "knobSmithAudio-module__lBZfra__knobsVideo",
  "knobsVideoContainer": "knobSmithAudio-module__lBZfra__knobsVideoContainer",
  "logoConstructionSection": "knobSmithAudio-module__lBZfra__logoConstructionSection",
  "logoRevealCaption": "knobSmithAudio-module__lBZfra__logoRevealCaption",
  "logoRevealSection": "knobSmithAudio-module__lBZfra__logoRevealSection",
  "logoWordmarkCaption": "knobSmithAudio-module__lBZfra__logoWordmarkCaption",
  "logoWordmarkImage": "knobSmithAudio-module__lBZfra__logoWordmarkImage",
  "logoWordmarkSection": "knobSmithAudio-module__lBZfra__logoWordmarkSection",
  "logoWordmarkWrapper": "knobSmithAudio-module__lBZfra__logoWordmarkWrapper",
  "metaBlock": "knobSmithAudio-module__lBZfra__metaBlock",
  "metaGrid": "knobSmithAudio-module__lBZfra__metaGrid",
  "metaLabel": "knobSmithAudio-module__lBZfra__metaLabel",
  "metaLeft": "knobSmithAudio-module__lBZfra__metaLeft",
  "metaOverview": "knobSmithAudio-module__lBZfra__metaOverview",
  "metaRight": "knobSmithAudio-module__lBZfra__metaRight",
  "metaSection": "knobSmithAudio-module__lBZfra__metaSection",
  "metaText": "knobSmithAudio-module__lBZfra__metaText",
  "metaTools": "knobSmithAudio-module__lBZfra__metaTools",
  "meterSection": "knobSmithAudio-module__lBZfra__meterSection",
  "meterVideo": "knobSmithAudio-module__lBZfra__meterVideo",
  "meterVideoWrapper": "knobSmithAudio-module__lBZfra__meterVideoWrapper",
  "ogImage": "knobSmithAudio-module__lBZfra__ogImage",
  "ogImageCaption": "knobSmithAudio-module__lBZfra__ogImageCaption",
  "ogImageSection": "knobSmithAudio-module__lBZfra__ogImageSection",
  "ogImageWrapper": "knobSmithAudio-module__lBZfra__ogImageWrapper",
  "page": "knobSmithAudio-module__lBZfra__page",
  "problemMindmap": "knobSmithAudio-module__lBZfra__problemMindmap",
  "storySection": "knobSmithAudio-module__lBZfra__storySection",
  "storySectionBeforeVuMeter": "knobSmithAudio-module__lBZfra__storySectionBeforeVuMeter",
  "swatchColor": "knobSmithAudio-module__lBZfra__swatchColor",
  "swatchDescription": "knobSmithAudio-module__lBZfra__swatchDescription",
  "swatchHex": "knobSmithAudio-module__lBZfra__swatchHex",
  "swatchInfo": "knobSmithAudio-module__lBZfra__swatchInfo",
  "swatchName": "knobSmithAudio-module__lBZfra__swatchName",
  "typeBody": "knobSmithAudio-module__lBZfra__typeBody",
  "typeCaption": "knobSmithAudio-module__lBZfra__typeCaption",
  "typeDisplay": "knobSmithAudio-module__lBZfra__typeDisplay",
  "typeHeadline": "knobSmithAudio-module__lBZfra__typeHeadline",
  "typeLabel": "knobSmithAudio-module__lBZfra__typeLabel",
  "typeRow": "knobSmithAudio-module__lBZfra__typeRow",
  "typeSample": "knobSmithAudio-module__lBZfra__typeSample",
  "typeSampleGeist": "knobSmithAudio-module__lBZfra__typeSampleGeist",
  "typeTitle": "knobSmithAudio-module__lBZfra__typeTitle",
  "typographySection": "knobSmithAudio-module__lBZfra__typographySection",
  "typographySectionDivider": "knobSmithAudio-module__lBZfra__typographySectionDivider",
  "typographyShowcase": "knobSmithAudio-module__lBZfra__typographyShowcase",
  "videoCaption": "knobSmithAudio-module__lBZfra__videoCaption",
  "videoContainer": "knobSmithAudio-module__lBZfra__videoContainer",
  "vuMeterSection": "knobSmithAudio-module__lBZfra__vuMeterSection",
  "webPresenceGrid": "knobSmithAudio-module__lBZfra__webPresenceGrid",
});
